import React from "react";
import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";
export default function ReceiptMonthWise() {
  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const { RecReceiptMonthdata } = useSelector(
    (state) => state.ReceivablePaybleSlice,
  );

  const getRows = RecReceiptMonthdata?.Detail?.map((label, index) => ({
    // srNumber: index + 1,
    chart: true,
    AcName: label.AcName,
    AprAmount: label.AprAmount,
    MayAmount: label.MayAmount,
    JunAmount: label.JunAmount,
    JulAmount: label.JulAmount,
    AugAmount: label.AugAmount,
    SepAmount: label.SepAmount,
    OctAmount: label.OctAmount,
    NovAmount: label.NovAmount,
    DecAmount: label.DecAmount,
    JanAmount: label.JanAmount,
    FebAmount: label.FebAmount,
    MarAmount: label.MarAmount,
    TotalAmount: label.TotalAmount,
  }));

  const getColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Total Balance",
      key: "TotalAmount",
      align: "right",
      format: true,
    },
    { label: "Apr", key: "AprAmount", align: "right", format: true },
    { label: "May", key: "MayAmount", align: "right", format: true },
    { label: "Jun", key: "JunAmount", align: "right", format: true },
    { label: "Jul", key: "JulAmount", align: "right", format: true },
    { label: "Aug", key: "AugAmount", align: "right", format: true },
    { label: "Sep", key: "SepAmount", align: "right", format: true },
    { label: "Oct", key: "OctAmount", align: "right", format: true },
    { label: "Nov", key: "NovAmount", align: "right", format: true },
    { label: "Dec", key: "DecAmount", align: "right", format: true },
    { label: "Jan", key: "JanAmount", align: "right", format: true },
    { label: "Feb", key: "FebAmount", align: "right", format: true },
    { label: "Mar", key: "MarAmount", align: "right", format: true },
  ];

  if (RecReceiptMonthdata === "no" || RecReceiptMonthdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            RECEIPT MOTHWISE
          </h2>
        </div>
        <FASTable data={getRows} columns={getColumns} />
      </div>
    </div>
  );
}
